<forge-card>
  @if (!loading) {
    <div>
      <div fxLayout="column" fxLayoutAlign="space-between">
        <form #form="ngForm">
          <div ngModelGroup="cardEdit" fxLayout="column">
            <metadata-panel [model]="model" [metadata]="metadata" class="standardMetadata" [dense]="dense">
          </metadata-panel>
        </div>
      </form>
    </div>
    <div class="actions" fxLayout="row" fxLayoutAlign="end center">
      <forge-button variant="outlined" attr.telemetry="Submission-MetadataCardCancel" (click)="cancel()">
      Cancel</forge-button>
      <forge-button variant="raised" attr.telemetry="Submission-MetadataCardSave" (click)="save()" [disabled]="!formIsValid()">
      Save</forge-button>
    </div>
  </div>
}
@if (loading) {
  <busy-indicator page="true"></busy-indicator>
}
</forge-card>
